// extracted by mini-css-extract-plugin
module.exports = {"about":"_2LfHKSI5ZbpBkznKNdj-le","row":"n8aJHq8rxjAt5pwEC4nwu","col":"LbkBSlREAd-IBvNlTk6i0","schoolLink":"p4cfHp5gPi2thk8OMYilz"};